import React from 'react';

// Shown INSTEAD of the quote builder when this calculation is already open in another tab of the same browser
// (see useFrankQuoteTabLock for why one tab at a time). The editor is never mounted behind this, so the second
// tab makes no autosaves and does not touch the shared response cache. "Try again" re-checks the lock: once the
// other tab is closed the browser has released it, so the check succeeds and the editor opens here.
const FrankQuoteAlreadyOpen = ({ onRetry }) => (
  <div
    className="container"
    data-frank-quote-already-open
    style={{ maxWidth: '520px', margin: '0 auto', padding: '60px 20px', textAlign: 'center' }}
  >
    <i
      className="fa fa-window-restore"
      aria-hidden="true"
      style={{ fontSize: '32px', color: 'var(--ink-faint, #8a94a3)', marginBottom: '16px' }}
    />
    <h2 style={{ fontSize: '20px', fontWeight: 600, color: 'var(--ink, #10141a)', margin: '0 0 12px' }}>
      {t('quote_builder.frank_already_open_heading')}
    </h2>
    <p style={{ fontSize: '14px', lineHeight: 1.5, color: 'var(--ink-soft, #4e5865)', margin: '0 0 24px' }}>
      {t('quote_builder.frank_already_open_body')}
    </p>
    <button
      type="button"
      data-frank-quote-already-open-retry
      className="dct-button dct-button--secondary"
      onClick={onRetry}
    >
      {t('quote_builder.frank_try_again')}
    </button>
  </div>
);

export default FrankQuoteAlreadyOpen;
